import banner_img from "../../assets/home/Group 159.png";
import banner_text_bg_1 from "../../assets/home/Rectangle 55.png";
import banner_text_bg_2 from "../../assets/home/Rectangle 53.png";
import banner_text_bg_3 from "../../assets/home/Rectangle 99.png";
import banner_text_bg_4 from "../../assets/home/Rectangle 50.png";
import '../style/home/H_Banner.css';
import { IoIosArrowDown } from "react-icons/io";



const H_Banner=()=>{
  return(
    <div className="h-banner">
      <div className="h-banner-text">
        <img className='h-banner-text-bg-1' src={banner_text_bg_1} alt="banner_text_bg" />
        <img className='h-banner-text-bg-2' src={banner_text_bg_2} alt="banner_text_bg" />
        <img className='h-banner-text-bg-3' src={banner_text_bg_3} alt="banner_text_bg" />
        <img className='h-banner-text-bg-4' src={banner_text_bg_4} alt="banner_text_bg" />
        <div className="h-banner-text-title">
          تعداد نیرو در یک رقابت مهم نیست بلکه فقط <span>تکیه بر نیروها</span> و پرسنل‌تان اهمیت دارد
        </div>
        <div className="h-banner-text-subtitle">
          لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد،
        </div>
      </div>
      <div className="h-banner-img">
        <img src={banner_img} alt="banner-img"/>
      </div>
      <IoIosArrowDown className="h-banner-text-arrow"/>
    </div>
  )
}

export default H_Banner;